import LoginComponent from "../../components/Auth/login";

export default function LoginScreen(){
return <LoginComponent />
}